type RawSystemInfo = {
  uptime?: unknown;
  uptime_available?: unknown;
  uptime_note?: unknown;
};

export interface NormalizedUptimeInfo {
  value: string;
  available: boolean;
  note: string;
  dashboardText: string;
}

const UNAVAILABLE_PATTERNS = [
  /^n\/a$/i,
  /tidak tersedia/i,
  /exec/i,
  /eksekusi/i,
  /dilarang/i,
];

const toTrimmedString = (value: unknown): string => {
  return typeof value === 'string' ? value.trim() : '';
};

export const normalizeSystemUptime = (
  info?: RawSystemInfo | null,
): NormalizedUptimeInfo => {
  const rawValue = toTrimmedString(info?.uptime);
  const rawNote = toTrimmedString(info?.uptime_note);
  const explicitAvailability =
    typeof info?.uptime_available === 'boolean' ? info.uptime_available : undefined;

  if (/^app proses:/i.test(rawValue)) {
    return {
      value: 'Tidak tersedia',
      available: false,
      note: 'Nilai fallback proses aplikasi tidak dipakai sebagai uptime server.',
      dashboardText: 'Monitoring sistem aktif',
    };
  }

  const looksUnavailable =
    rawValue === '' ||
    UNAVAILABLE_PATTERNS.some((pattern) => pattern.test(rawValue));

  if (explicitAvailability === false || looksUnavailable) {
    return {
      value: 'Tidak tersedia',
      available: false,
      note: rawNote || 'Info uptime server tidak tersedia pada konfigurasi ini.',
      dashboardText: 'Monitoring sistem aktif',
    };
  }

  return {
    value: rawValue,
    available: true,
    note: rawNote || 'Status uptime server terdeteksi.',
    dashboardText: `Uptime ${rawValue}`,
  };
};
